import { ENV } from "../utils";
export class MaterialAgent {
  baseApi = ENV.BASE_API;
  async getMaterialAgents(accessToken, active = true) {
    const r = await fetch(`${this.baseApi}/material-agents?active=${active}`, { headers: { Authorization: `Bearer ${accessToken}` } });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async createMaterialAgent(accessToken, data) {
    const r = await fetch(`${this.baseApi}/add-material-agent`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(data) });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async updateMaterialAgent(accessToken, id, data) {
    const r = await fetch(`${this.baseApi}/update-material-agent/${id}`, { method: "PUT", headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(data) });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async deleteMaterialAgent(accessToken, id) {
    const r = await fetch(`${this.baseApi}/delete-material-agent/${id}`, { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
}
